import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "aegis"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return ($setup.showAegis)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          src: $setup.aegis,
          alt: "",
          style: {"width":"100vw"}
        }, null, 8 /* PROPS */, _hoisted_2)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        ($setup.ios && !!$setup.videoAd)
          ? _withDirectives((_openBlock(), _createElementBlock("iframe", {
              key: 0,
              id: "playiframe",
              src: $setup.videoUrl + '?poster=' + $setup.videoPoster + '&ad=' + $setup.videoAd + '&ver=' + $setup.curversion,
              frameborder: "0",
              style: {"height":"56vw","width":"100%","position":"fixed","z-index":"999","top":"40px"},
              allow: "autoplay",
              scrolling: "no",
              frameBorder: "0",
              allowFullScreen: ""
            }, null, 8 /* PROPS */, _hoisted_4)), [
              [_vShow, $setup.roomPlayer]
            ])
          : _createCommentVNode("v-if", true),
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            (_openBlock(), _createBlock(_KeepAlive, null, [
              (_ctx.$route.meta.keepAlive)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                    key: _ctx.$route.path
                  }))
                : _createCommentVNode("v-if", true)
            ], 1024 /* DYNAMIC_SLOTS */)),
            (!_ctx.$route.meta.keepAlive)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: 0 }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        (_ctx.$route.meta.tab)
          ? (_openBlock(), _createBlock($setup["layout"], { key: 1 }))
          : _createCommentVNode("v-if", true),
        _createVNode($setup["Popups"]),
        _createVNode($setup["Ann"], { "z-index": "99999" }),
        _createVNode(_component_van_action_sheet, {
          show: $setup.showLogin,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($setup.showLogin) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode($setup["Login"], {
              "on-close": () => $setup.showLogin = false,
              success: $setup.loginAccSuccess
            }, null, 8 /* PROPS */, ["on-close"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["show"]),
        _createVNode(_component_van_action_sheet, {
          show: $setup.showSetNickName,
          "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (($setup.showSetNickName) = $event)),
          "close-on-click-overlay": false,
          "z-index": "99999"
        }, {
          default: _withCtx(() => [
            _createVNode($setup["SetNickName"], {
              "on-close": () => $setup.showSetNickName = false
            }, null, 8 /* PROPS */, ["on-close"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["show"])
      ]))
}